<template>
    <div class="page white_bg">

        <div><!-- set height if pageHeader is fixed position -->
            <header class="pageHeader white_bg" style="line-height: 24px;">
                <div class="borderLayout paddingH16 paddingV8">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 24px">
                            <span class="icon leftAngleBracketIcon floatL" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 24px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
            <div class="generalPagePaddingH">
                <ul class="list">
                    <li class="item paddingV16 clearfix" v-for="dataItem in dataList" :key="dataItem.id">
                        <div class="fl">
                            <div class="font14r lineHeight24r14f" style="color: hsla(0, 0%, 17%, 1);">
                                已充值{{dataItem.price}}元
                            </div>
                            <div class="font12r lineHeight20r12f" style="color: hsla(219, 9%, 39%, 1);">
                                {{formatDateTime(dataItem.createTime)}}
                            </div>
                        </div>
                        <div class="fr font14r red" style="padding-top: 10px;">+{{dataItem.rechargeCount}}次下载次数</div>
                    </li>
                </ul>

                <div class="alignCenter colorCCC bold" v-show="status == 'ready' && dataList.length < 1">
                    <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" />
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// util
import consoleHelper    from '@/util/consoleHelper';
import numberHelper     from '@/util/numberHelper';
import appHelper        from '@/util/appHelper';
import arrayHelper      from "@/util/arrayHelper";

const config = {
    name : 'rechargeHistory',
    title : '充值明细',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/mini/courseware/history',
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo'
        }
    },
    methods : {

    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            for (let i=1; i<=8; i++)
            {
                this.dataList.push({
                    id : i,
                    price : numberHelper.getRandomInteger(30),
                    rechargeCount : numberHelper.getRandomInteger(100),
                    createTime : new Date().getTime() - numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7)
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: hsla(2, 100%, 61%, 1);
}
.list {
    .item {
        padding: 16px 0 4px;
    }
}
</style>
